/**
 * House of Places — header wishlist heart.
 *
 * The Pasilobus Wishlists app draws its own floating corner button
 * (#floating-wishlist-btn) that opens the "My List" panel. The header heart
 * reuses that button (hidden by CSS) so the shopper gets the app's own panel,
 * with its "View Wishlist" link into their account. If the app script has not
 * loaded, the heart falls back to the app's wishlist page.
 *
 * The count comes from the app's cache in localStorage
 * (wishlist_cache_<guest or customer id> → data.count). The newest cache entry
 * wins. It is re-read when another tab changes it and on a light interval,
 * because the app writes the cache after its own network round trip.
 */
(function () {
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-header-wishlist']) return;
  yuklu['hop-header-wishlist'] = true;

  var YEDEK_ADRES = '/a/wishlist';

  function sayiOku() {
    var enYeni = null;
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var anahtar = localStorage.key(i);
        if (!anahtar || anahtar.indexOf('wishlist_cache_') !== 0) continue;
        var kayit = JSON.parse(localStorage.getItem(anahtar));
        if (!kayit || !kayit.data) continue;
        if (!enYeni || (kayit.ts || 0) > (enYeni.ts || 0)) enYeni = kayit;
      }
    } catch (e) {
      return 0;
    }
    if (!enYeni) return 0;
    var d = enYeni.data;
    if (typeof d.count === 'number') return d.count;
    if (Array.isArray(d.wishlistItems)) return d.wishlistItems.length;
    return 0;
  }

  var sonSayi = -1;
  function boya() {
    var sayi = sayiOku();
    if (sayi === sonSayi) return;
    sonSayi = sayi;
    document.querySelectorAll('[data-hop-wishlist-count]').forEach(function (rozet) {
      rozet.textContent = sayi > 99 ? '99+' : String(sayi);
      rozet.hidden = sayi < 1;
    });
    document.querySelectorAll('[data-hop-wishlist-open]').forEach(function (b) {
      var etiket = b.getAttribute('data-label') || 'Wishlist';
      b.setAttribute('aria-label', sayi > 0 ? etiket + ' (' + sayi + ')' : etiket);
    });
  }

  document.addEventListener('click', function (e) {
    var buton = e.target.closest('[data-hop-wishlist-open]');
    if (!buton) return;
    e.preventDefault();
    var uygulamaButonu = document.getElementById('floating-wishlist-btn');
    if (uygulamaButonu) {
      uygulamaButonu.click();
    } else {
      window.location.href = buton.getAttribute('href') || YEDEK_ADRES;
    }
  });

  window.addEventListener('storage', function (e) {
    if (!e.key || e.key.indexOf('wishlist_cache_') === 0) boya();
  });

  // Saving from a product heart updates the cache a moment later.
  document.addEventListener('click', function () {
    setTimeout(boya, 800);
    setTimeout(boya, 2000);
  });

  setInterval(boya, 3000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boya);
  } else {
    boya();
  }
})();
